<div class="homeCardLogsListAreaHeader">
    <span class="homeCardLogsListAreaHeading">{{
      "CARDOPERATIONS_CARD_DETAIL_CARDALIAS_LABEL" | translate
    }}</span>
    <span class="homeCardLogsListAreaHederAlias">{{ modalInput }}</span>
    <div class="cardDateRange">
      <app-date-picker
        [width]="'200px'"
        [submitted]="dateSubmitted"
        [cardDetailPickerminDate]="cardDetailPickerminDate"
        [cardDetailPickermaxDate]="cardDetailPickermaxDate"
        (date) = "cardDetail_DateChanged($event)"
      ></app-date-picker>
    </div>
</div>
<div class="spacer50"></div>
<div *ngIf="!isLoading">
    <a
      type="submit"
      class="btn-primary center-block btn-lg"
      (click)="cardDetail_onClick()"
      [innerHTML]="
        'CARDOPERATIONS_CARD_DETAIL_QUERY_BUTTON_LABEL' | translate
      "
    ></a>
  </div>
  <div
    *ngIf="isLoading"
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgb(250, 248, 248);
    "
  >
    <mat-progress-spinner color="primary" mode="indeterminate">
    </mat-progress-spinner>
  </div>
  <div class="spacer10"></div>
  <div *ngIf="cardTransactionResult.length > 0">
    <mat-tab-group #cardDetailTabGroup mat-align-tabs="center" [(selectedIndex)]="cardDetailTabGroupIndex"
      >
      <mat-tab label="{{'CARDOPERATIONS_CARD_DETAIL_TAB1_LABEL' | translate}}">
        <ng-template mat-tab-label>
          <span
            class="round-tab"
            title="{{ 'CARDOPERATIONS_CARD_DETAIL_TAB1_LABEL' | translate }}"
          >
            <i class="icon icon-balance_charge"></i>
          </span>
        </ng-template>
        <div>
          <ul>
            <ng-container *ngFor="let transaction of cardTransactionResult">
              <li *ngIf="transaction.type==='0'">
                <i class="icon icon-balance_charge"></i>
                <span class="operationInfo">{{ transaction.description}}
                  <div class="operationWrapper">
                    <div class="opetationTime">{{ transaction.formattedDate }}</div>
                    <div class="statementCardAmount statementCardConfig">{{ transaction.amount }} {{ apiSettings.city.currency}}</div>
                  </div>
                </span>
              </li>
            </ng-container>
          </ul>
        </div>
      </mat-tab>

      <mat-tab
        label="{{ 'CARDOPERATIONS_CARD_DETAIL_TAB2_LABEL' | translate }}"
      >
        <ng-template mat-tab-label>
          <span
            class="round-tab"
            title="{{ 'CARDOPERATIONS_CARD_DETAIL_TAB1_LABEL' | translate }}"
          >
            <i class="icon icon-home_bus"></i>
          </span>
        </ng-template>
        <div>
          <ul>
            <ng-container *ngFor="let transaction of cardTransactionResult">
              <li *ngIf="transaction.type==='1'">
                <i class="icon icon-home_bus"></i>
                <span class="operationInfo">
                    {{ transaction.description}}
                    <div class="operationWrapper">
                        <div class="operationTime">
                            {{ transaction.formattedDate }}
                        </div>
                        <div class="statementCardAmountUsage statementCardConfig">
                            {{ transaction.usageAmt }} {{ apiSettings.city.currency }}
                        </div>
                    </div>
                </span>
              </li>
            </ng-container>
          </ul>
        </div>
      </mat-tab>
    </mat-tab-group>
</div>